import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';

@Component({
  selector: 'app-timeline-toggle-expand',
  templateUrl: './timeline-toggle-expand.component.html',
  styleUrl: './timeline-toggle-expand.component.scss',
  standalone: false,
})
export class TimelineToggleExpandComponent extends BaseComponent implements OnInit {
  public isExpanded: boolean = true;
  public hasExpandableNodes: boolean = false;

  constructor(private toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
  }

  ngOnInit(): void {
    this.subscribers.hasExpandableNodes = this.toolbarEventManagerHelper.$TimelineToolbarHasExpandableNodes.subscribe({
      next: (hasNodes: boolean) => {
        this.hasExpandableNodes = hasNodes;
      },
      error: (err: unknown) => {
        console.error('TimelineToggleExpand: failed to receive expandable nodes state', err);
      },
    });

    this.subscribers.isAllExpanded = this.toolbarEventManagerHelper.$TimelineToolbarIsAllExpanded.subscribe({
      next: (isExpanded: boolean) => {
        this.isExpanded = isExpanded;
      },
      error: (err: unknown) => {
        console.error('TimelineToggleExpand: failed to receive expanded state', err);
      },
    });
  }

  public onToggleExpand(): void {
    if (!this.hasExpandableNodes) {
      return;
    }
    this.toolbarEventManagerHelper.emitTimelineToolbarToggleExpand();
  }
}
